import React from 'react'
import StageContainer from '../../containers/admin_portal/stage';
const StagePage = () => {
  return (
    <div>
      <StageContainer/>
    </div>
  )
}

export default StagePage;
